import React, { useState } from "react";
import ViewCoupons from "./ViewCoupons";
import CreateCoupon from "./CreateCoupon";
import OneCoupon from "./OneCoupon";

export default function Coupon({id}) {

  const [currentView,setCurrentView] = useState("MainPage")
  const [selectedCouponId,setSelectedCouponId] = useState(null)

  

  const changeView = (e) => {
    setCurrentView(e)
  }
  const selectCoupon = (e) => {
    setSelectedCouponId(e)
  }

  const renderComponent = () => {
    switch (currentView) {
      case "OneCoupon":
        return <OneCoupon selectedCouponId={selectedCouponId} changeView={changeView} />;
      case "CreateCoupon":
        return <CreateCoupon id={id} changeView={changeView} />;
      case "MainPage":
        return <ViewCoupons selectCoupon={selectCoupon} changeView={changeView} currentView={currentView} />;
      default:
        return null;
    }
  };



  return (
    <div>
      {renderComponent()}
    </div>
  );
}
